<template>
  <div class="miya-login">
    <login-left></login-left>
    <div class="right-box">
      <div class="login-lang">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('menu.backHome')"
          placement="bottom"
        >
          <div class="btnBack" @click.stop="$router.push('/home')"></div>
        </el-tooltip>
        <miya-lang></miya-lang>
      </div>
      <div class="card">
        <h1 class="title1 fontSH">{{ $t("login.title1") }}</h1>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <p class="inputName">{{ $t("login.email") }}</p>
          <el-form-item label="" prop="email" label-width="0">
            <el-input
              size="medium"
              v-model="ruleForm.email"
              :placeholder="$t('login.placeholder1')"
            >
              <!-- <template slot="append">
                <el-select class="selectMail" filterable clearable v-model="suffix">
                  <el-option v-for="(item, idx) in list" :key="'email'+idx" :label="item" :value="item"></el-option>
                </el-select>
              </template> -->
            </el-input>
          </el-form-item>
          <p class="inputName">{{ $t("login.password") }}</p>
          <el-form-item label="" prop="password" label-width="0">
            <el-input
              show-password
              size="medium"
              v-model="ruleForm.password"
              :placeholder="$t('login.errorPassword')"
              @keyup.enter.native="clickLogin()"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="checkbox">
          <el-checkbox v-model="checked"></el-checkbox>
          <p class="checkText">
            {{ $t("login.checkedText")
            }}<span class="click" @click="clickTos">{{
              $t("login.checkedText1")
            }}</span>
          </p>
        </div>
        <miya-btn
          ref="miyaBtn"
          @click="clickLogin()"
          :title="$t('login.login')"
          class="loginBtn"
        ></miya-btn>
        <p class="checkText account">
          <span
            >{{ $t("login.noAccount")
            }}<span class="click" @click.stop="$router.push('/signup')">{{
              $t("login.signup")
            }}</span></span
          ><span
            class="forgetPassword"
            @click.stop="$router.push('/resetPassword')"
            >{{ $t("login.forgetPassword") }}</span
          >
        </p>
      </div>
    </div>
    <miya-tos ref="miyaTos" @clickOK="checked = true"></miya-tos>
  </div>
</template>
<script>
import loginLeft from "./loginLeft.vue";
import miyaTos from "./tos.vue";
import miyaLang from "@components/lang.vue";
import miyaBtn from "@components/miyaBtn.vue";
import { setToken } from "@assets/js/http.js";
export default {
  data() {
    var validateMail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("login.errorEmail")));
      } else if (!this.suffix) {
        var regex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        if (!regex.test(value)) {
          callback(new Error(this.$t("login.errorEmail")));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      suffix: "",
      list: [
        "@qq.com",
        "@163.com",
        "@gmail.com",
        "@126.com",
        "@msn.cn",
        "@live.com",
        "@lcx.cc",
        "@vip.qq.com",
        "@vip.163.com",
        "@aliyun.com",
        "@sina.cn",
        "@sina.com",
        "@sohu.com",
        "@21cn.com",
        "@189.cn",
        ".edu.cn",
        "@yeah.net",
        "@foxmail.com",
        "@icloud.com",
        "@bayblue.hk",
        "@proton.me",
        "@protonmail.com",
        "@pm.me",
      ],
      testUser: ["testuser123", "testuser"],
      checked: false,
      ruleForm: {
        email: "",
        password: "",
      },
      rules: {
        email: [{ validator: validateMail, trigger: "change" }],
        password: [
          {
            required: true,
            message: this.$t("login.errorPassword"),
            trigger: "change",
          },
        ],
      },
      isValidate: false,
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$get("/Check/GetStatus").then((res) => {
        if (res.code === 200) {
          this.$router.push("/dashboard");
        }
      });
    },
    getData() {
      this.rules.email[0].message = this.$t("login.errorEmail");
      this.rules.password[0].message = this.$t("login.errorPassword");
      if (this.isValidate) {
        this.$refs.ruleForm.validate((v) => {});
      }
    },
    clickLogin() {
      let isTest = this.testUser.findIndex((val) => {
        return val === this.ruleForm.email;
      });
      if (!this.checked) {
        this.$message.error(this.$t("login.error1"));
      } else if (
        isTest >= 0 &&
        this.ruleForm.password.length > 0 &&
        this.checked
      ) {
        this.login(this.ruleForm.email);
      } else {
        this.$refs.ruleForm.validate((v) => {
          this.isValidate = true;
          if (v) {
            this.login();
          }
        });
      }
    },
    login(account) {
      this.$refs.miyaBtn.disabledBtn();
      this.$post(`/Check/Login`, {
        account: account
          ? account
          : !this.suffix
          ? this.ruleForm.email
          : this.ruleForm.email + this.suffix,
        password: this.ruleForm.password,
      }).then((res) => {
        this.getIPAddress().then((ip) => {
          var date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");

          // 替换格式字符串中的占位符
          var createTime = "yyyy-MM-dd HH:mm:ss"
            .replace("yyyy", year)
            .replace("MM", month)
            .replace("dd", day)
            .replace("HH", hours)
            .replace(
              "hh",
              hours > 12 ? String(hours - 12).padStart(2, "0") : hours
            )
            .replace("mm", minutes)
            .replace("ss", seconds)

          this.$post(`/SysLogs/Add`, {
            Content: "",
            TypeName: "登录",
            TypeId: "",
            Href: "",
            CreateTime: createTime,
            CreateId: this.ruleForm.email,
            CreateName: this.ruleForm.email,
            Ip: ip,
            Result: 0,
            Application: "web",
          });
        });
        this.$refs.miyaBtn.enabledBtn();
        if (res.code === 500) {
          this.$message.error(this.$t("login.error2"));
        } else if (res.code === 200) {
          setToken(res.token);
          this.$router.push("/dashboard");
        }
      });
    },
    async getIPAddress() {
      const ipServices = [
        "https://ipinfo.io/json",
        "https://api.ipify.org?format=json",
        "https://ipapi.co/json/",
        "https://api.my-ip.io/ip.json",
      ];
      try {
        // 尝试多个API直到成功
        for (const service of ipServices) {
          try {
            const response = await fetch(service);

            if (!response.ok) {
              throw new Error(`API服务不可用: ${service}`);
            }

            const data = await response.json();

            // 不同API返回的数据结构不同
            const ip = data.ip || data.ip_address || data.query;

            if (ip) {
              return ip;
            }
          } catch (err) {
            console.log(`服务失败: ${service}`, err);
          }
        }

        // 所有服务都失败
        throw new Error("无法从任何服务获取IP地址");
      } catch (error) {
        console.error("获取IP地址失败:", error);
      }
    },
    clickTos() {
      this.$refs.miyaTos.show();
    },
  },
  beforeDestroy() {},
  watch: {
    language() {
      this.getData();
    },
  },
  components: { loginLeft, miyaLang, miyaBtn, miyaTos },
};
</script>
<style scoped lang="stylus">
.miya-login
  display flex
  min-height 100vh
  .right-box
    flex 1
    padding-bottom 36px
    .login-lang
      padding-right 48px
      display flex
      line-height 72px
      justify-content right
      .btnBack
        cursor pointer
        width 20px
        margin 26px
        background-image url('../../assets/images/icon/home.svg')
        &:hover
          background-image url('../../assets/images/icon/home1.svg')
    .card
      width 40%
      min-width 450px
      margin 30px auto 0 auto
      color $c1
    .title1
      font-size 40px
      text-align center
      margin-bottom 56px
    .inputName
      font-size $f16
      margin 36px 0 12px 0
      fontWeight()
    .checkbox
      margin-top 64px
      display flex
    .checkText
      font-size 16px
      color $c1
      line-height 20px
      margin-left 8px
      .click
        color $c8
        cursor pointer
    .loginBtn
      line-height 54px
      text-align center
      letter-spacing 1px
      color $c7
      border-radius 2px
      font-size $f18
      margin 16px 0
      width 100%
      border none
      background: linear-gradient(88deg, #FF8F10 0%, #FF6F00 100%);
      &:hover
        box-shadow: 0px 8px 15px 1px rgba(255,201,159,0.6);
    .account
      display flex
      justify-content space-between
      color $c2
      margin-left 0
      .forgetPassword
        color $c1
        cursor pointer
        &:hover
          color $c8
@media screen and (max-width: 800px)
  .miya-login
    display block
    .right-box
      position relative
      z-index 3
      width calc(100% - 2rem)
      margin 0 auto
      .login-lang
        color $c7
        padding-right 0
        .btnBack
          width 1.4rem
          height 1.4rem
          margin 1rem 1.5rem 0 0
          background-size 100% 100%
      .card
        width 100%
        min-width 320px
        background-color rgba(255,255,255,0.1)
        backdrop-filter blur(8px)
        border 1px solid rgba(255,255,255,0.2)
        border-radius 4px
        padding 1rem 1rem 0.8rem 1rem
        .title1
          color $c7
          font-size 1.2rem
      .checkText
        color $c5
        font-size 0.7rem
      .account
        display block
        text-align center
        .forgetPassword
          color $c7
          display block
          margin-top 1rem
          color $c8
      .inputName
        color $c7
        font-size 0.7rem
</style>
<style lang="stylus">
.miya-login
  .el-input__inner
    border 1px solid #f5f5f5
  .el-input__inner:focus
    border 1px solid $c8
  .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus
    background rgba(255,57,35,0.06)
  .el-form-item.is-error .selectMail .el-input__inner, .el-form-item.is-error .selectMail .el-input__inner:focus, .el-form-item.is-error .selectMail .el-textarea__inner, .el-form-item.is-error .selectMail .el-textarea__inner:focus
    background transparent
  .el-input-group__append, .el-input-group__prepend
    width 140px
    border 1px solid $c4
    .is-disabled
      color $c4
  .el-form-item__error
    font-size 14px
  .el-input .el-input__clear
    font-size 16px
    color $c2
  .el-checkbox__inner
    width 20px
    height 20px
  .el-checkbox__inner::after
    width 6px
    height 12px
    left 5px
</style>
